import React from "react";
import { SlugStatus } from "../hooks/useSlugValidation";
import { generateSlug, sanitizeSlugInput } from "../utils/slugUtils";
import Input from "./Input";

interface SlugInputFieldProps {
  value: string;
  onChange: (slug: string) => void;
  onBlur: (slug: string) => void;
  onResetStatus: () => void;
  title: string;
  urlPrefix: string;
  slugStatus: SlugStatus;
  disabled?: boolean;
  convertPlaceholder?: boolean;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  available: { label: "✓ Available", className: "text-green-600" },
  taken: { label: "✗ Already in use", className: "text-red-500" },
  checking: { label: "Checking...", className: "text-gray-400" },
};

export default function SlugInputField({
  value,
  onChange,
  onBlur,
  onResetStatus,
  title,
  urlPrefix,
  slugStatus,
  disabled = false,
  convertPlaceholder = true,
}: SlugInputFieldProps) {
  const placeholder = generateSlug(title || "");
  const config = statusConfig[slugStatus];

  return (
    <div>
      <Input
        label="Slug"
        value={value}
        onChange={(e) => {
          onResetStatus();
          onChange(sanitizeSlugInput(e.target.value));
        }}
        onBlur={(e) => onBlur(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        convertPlaceholder={!disabled && convertPlaceholder}
        TopRightElement={
          !disabled && value.trim() && config ? (
            <span className={`text-xs font-medium ${config.className}`}>
              {config.label}
            </span>
          ) : undefined
        }
      />
      {!disabled && (
        <p className="text-xs text-gray-400 mt-1">
          Used in the URL: {urlPrefix}
          <strong>{value || placeholder}</strong>
        </p>
      )}
    </div>
  );
}
